import React, { useState, useEffect, useMemo } from "react";
import InstanceAction from "components/instanceAction";
import { InstancesPanel } from "./styles";
import Table from "components/table";
import Filter from "components/button/filter";

const DEFAULT_VISIBLE_COLUMNS = [
  "name",
  "power",
  "ou",
  "cpu",
  "ram",
  "disk",
  "vgpu",
];

const tags = [
  { name: "name", type: "text", width: "20px" },
  { name: "power", type: "power", width: "5px" },
  { name: "kind", type: "text", width: "9px" },
  { name: "connect", type: "power", width: "5px" },
  { name: "login", type: "text", width: "8px" },
  { name: "owner", type: "text", width: "8px" },
  { name: "ou", type: "text", width: "10px" },
  { name: "cpu", type: "text", width: "4px" },
  { name: "ram", type: "text", width: "4px" },
  { name: "disk", type: "text", width: "5px" },
  { name: "vgpu", type: "text", width: "4px" },
  { name: "vgpu_pci", type: "text", width: "4px" },
  { name: "network", type: "text", width: "4px" },
  { name: "ip", type: "text", width: "15px" },
  { name: "internet", type: "power", width: "5px" },
  { name: "os", type: "text", width: "20px" },
  { name: "anyware_users", type: "text", width: "20px" },
  { name: "hypervisor", type: "text", width: "20px" },
  { name: "hostsystem", type: "text", width: "20px" },
];
const InstanceTable = ({ open, instances }) => {
  const [selectInstances, setSelectInstances] = useState();
  const [filterData, setFilterData] = useState<Record<string, boolean>>({});

  useEffect(() => {
    const initialFilter: Record<string, boolean> = {};
    tags.forEach((col) => {
      initialFilter[col.name] = DEFAULT_VISIBLE_COLUMNS.includes(col.name);
    });
    setFilterData(initialFilter);
  }, []);

  const visibleTags = useMemo(() => {
    return tags.filter((col) => filterData[col.name]);
  }, [filterData]);

  return (
    <InstancesPanel $open={open} onClick={(e) => e.stopPropagation()}>
      <div style={{ display: "flex", gap: "10px" }}>
        <InstanceAction selectInstances={selectInstances} />
        <Filter
          tag={Object.keys(filterData)}
          value={filterData}
          onApply={(next) => setFilterData((prev) => ({ ...prev, ...next }))}
        />
      </div>
      <Table
        tags={visibleTags}
        data={instances}
        isCheck={true}
        setCheckData={setSelectInstances}
      />
    </InstancesPanel>
  );
};

export default InstanceTable;
